import Actividades from "../components/Organizaciones/Actividades";
import FormularioActividad from "../components/Organizaciones/FormularioActividad";
import Organizaciones from "../components/Organizaciones/Organizaciones";
import FormularioOrganizacion from "../components/Organizaciones/FormularioOrganizacion";
import InformeOrganizaciones from "../components/Caracterizacion/Administrativos/InformeOrganizaciones";

export const OrganizacionesRoutes = [
    { path: '/organizaciones/listar', element: <Organizaciones /> },
    { path: '/organizaciones/mostrarformulario/:id', element: <FormularioOrganizacion /> },
    { path: '/organizaciones/:organizacionId/actividades', element: <Actividades /> },
    { path: '/organizaciones/:organizacionId/formularioactividad/:id', element: <FormularioActividad /> },
    { path: '/organizaciones/informe/organizaciones', element: <InformeOrganizaciones /> },
];